export default __webpack_public_path__ + "static/tomatbonde-ac4ad428caceac79ab8ca5ffc14a19df.jpg";